import { render, staticRenderFns } from "./TaxChoices.vue?vue&type=template&id=76c9ef09&scoped=true"
import script from "./TaxChoices.vue?vue&type=script&lang=js"
export * from "./TaxChoices.vue?vue&type=script&lang=js"
import style0 from "./TaxChoices.vue?vue&type=style&index=0&id=76c9ef09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c9ef09",
  null
  
)

export default component.exports